/**
 * Emoji Icon Constants
 *
 * Centralized emoji icon definitions organized by category
 */

// FEATURE ICONS - Used in product features and key highlights
export const FEATURE_ICONS = {
  // Search & Discovery
  SEARCH: "🔍",
  MAGNIFYING_GLASS: "🔍",
  DETECTIVE: "🔍",

  // Speed & Performance
  LIGHTNING: "⚡",
  FAST: "⚡",
  REALTIME: "⚡",
  SPEED: "⚡",

  // AI & Technology
  ROBOT: "🧠",
  AI: "🧠",
  ARTIFICIAL_INTELLIGENCE: "🧠",

  // Analytics & Reports
  BAR_CHART: "📊",
  REPORTS: "📊",
  ANALYTICS: "📊",
  DATA: "📊",
  CHART: "📈",
  TRENDING_UP: "📈",

  // Targeting & Precision
  TARGET: "🎯",
  PRECISION: "🎯",
  FOCUS: "🎯",
  GOAL: "🎯",

  // Creative & Design
  PALETTE: "🎨",
  DESIGN: "🎨",
  CREATIVE: "🎨",
  ART: "🎨",

  // Legal & Compliance
  SCALE: "⚖️",
  LAW: "⚖️",
  LEGAL: "⚖️",
  BALANCE: "⚖️",

  // Security & Protection
  SHIELD: "🛡️",
  SECURITY: "🛡️",
  PROTECTION: "🛡️",
  SECURE: "🛡️",

  // Innovation & Growth
  ROCKET: "🚀",
  LAUNCH: "🚀",
  INNOVATION: "🚀",
  GROWTH: "🚀",
};

// BUSINESS ICONS - Used in business contexts and commercial features
export const BUSINESS_ICONS = {
  // Professional & Corporate
  BRIEFCASE: "💼",
  BUSINESS: "💼",
  CORPORATE: "💼",
  PROFESSIONAL: "💼",

  // Financial
  MONEY: "💰",
  DOLLAR: "💰",
  REVENUE: "💰",
  PROFIT: "💰",
  PRICING: "💰",

  // Documentation & Planning
  CLIPBOARD: "📋",
  DOCUMENT: "📋",
  PLANNING: "📋",
  CHECKLIST: "📋",

  // Vision & Monitoring
  EYE: "👁️",
  VISION: "👁️",
  MONITORING: "👁️",
  WATCH: "👁️",
};

// TECHNICAL ICONS - Used in technical documentation and development
export const TECHNICAL_ICONS = {
  // Development & Tools
  WRENCH: "🔧",
  TOOLS: "🔧",
  DEVELOPMENT: "🔧",
  CONFIGURATION: "🔧",

  // API & Integration
  PACKAGE: "📦",
  API: "📦",
  INTEGRATION: "📦",
  MODULE: "📦",

  // Security & Access
  LOCK: "🔐",
  SECURITY_KEY: "🔐",
  ACCESS: "🔐",
  AUTHENTICATION: "🔐",
};

// CONTENT ICONS - Used in articles and content sections
export const CONTENT_ICONS = {
  // Highlights & Features
  STAR: "🌟",
  HIGHLIGHT: "🌟",
  FEATURED: "🌟",

  // Learning & Education
  BULB: "💡",
  IDEA: "💡",
  INSIGHT: "💡",
  TIP: "💡",

  // Entertainment & Media
  THEATER: "🎭",
  PERFORMANCE: "🎭",
  SHOWCASE: "🎭",
  DEMO: "🎭",

  // Magic & Innovation (for AI articles)
  CRYSTAL_BALL: "🔮",
  MAGIC: "🔮",
  PREDICTION: "🔮",
  FUTURE: "🔮",

  // Achievements & Success
  TROPHY: "🏆",
  ACHIEVEMENT: "🏆",
  SUCCESS: "🏆",
  WINNER: "🏆",

  // Ranking & Recognition
  MEDAL: "🎖️",
  RECOGNITION: "🎖️",
  AWARD: "🎖️",
  HONOR: "🎖️",

  // Excellence & First Place
  GOLD_MEDAL: "🥇",
  FIRST_PLACE: "🥇",
  EXCELLENCE: "🥇",
  CHAMPION: "🥇",

  // Premium & Professional Quality
  DIAMOND: "💎",
  GEM: "💎",
  PREMIUM: "💎",
  LUXURY: "💎",
};

// STATUS ICONS - Used for feedback, alerts, and status indicators
export const STATUS_ICONS = {
  // Warnings & Alerts
  WARNING: "⚠️",
  ALERT: "⚠️",
  CAUTION: "⚠️",
  ATTENTION: "⚠️",

  // Success & Positive
  CHECK: "✅",
  SUCCESS: "✅",
  APPROVED: "✅",
  COMPLETED: "✅",

  // Information & Tips
  INFO: "ℹ️",
  INFORMATION: "ℹ️",
  HELP: "ℹ️",
  GUIDE: "ℹ️",
};
